<template>
    <div class="device-type-add">
        <el-page-header @back="goBack" content="编辑健康管理助理"></el-page-header>
        <el-form label-position="right" :model="ruleForm" :rules="rules" ref="ruleForm" label-width="150px" class="form"
                 style="width: 40%;margin: 20px auto 0 auto;min-width: 810px;" autocomplete="off">
            <el-form-item label="健康管理助理姓名" prop="user_name" v-if="is_user_name">
                <el-input type="text" v-model="ruleForm.user_name" placeholder="请输入健康管理助理姓名" maxlength="5"
                          @input="userNameCheck" autocomplete="off"
                          style="width: 100%;"></el-input>
            </el-form-item>
            <el-form-item label="健康管理助理姓名" prop="user_name" class="is-error" v-else>
                <el-input type="text" v-model="ruleForm.user_name" placeholder="请输入健康管理助理姓名" maxlength="5"
                          @input="userNameCheck" autocomplete="off"
                          style="width: 100%;"></el-input>
                <div class="el-form-item__error">请输入2-5个字的中文姓名</div>
            </el-form-item>
            <el-form-item label="手机号码" prop="mobile">
                <el-input type="text" v-model="ruleForm.mobile" placeholder="请输入手机号码" autocomplete="off"
                          style="width: 100%;"></el-input>
            </el-form-item>
            <el-form-item label="身份证号码" prop="idcard">
                <el-input type="text" v-model="ruleForm.idcard" placeholder="请输入身份证号码" autocomplete="off"
                          style="width: 100%;"></el-input>
            </el-form-item>
            <el-form-item label="银行卡号">
                <el-input type="text" v-model="ruleForm.bank_card" placeholder="请输入银行卡号" autocomplete="off"
                          style="width: 100%;"></el-input>
            </el-form-item>
            <el-form-item label="职务">
                <el-input type="text"  v-model="ruleForm.posistion" placeholder="请输入职务"
                          autocomplete="off"
                          style="width: 100%;"></el-input>
            </el-form-item>
            <el-form-item label="绑定健康管理专家">
                <el-autocomplete class="doctor_search"
                                 v-model="ruleForm.doctor_name"
                                 :fetch-suggestions="getDoctor"
                                 placeholder="请输入健康管理专家关键词"
                                 @select="doctorSelect"
                                 @blur="resetDoctorInfo"
                ></el-autocomplete>
            </el-form-item>
            <el-form-item label="单位" prop="hospital_id">
                <el-input disabled type="text" :disabled="true" v-model="ruleForm.hospital_name" placeholder="请选择单位"
                          autocomplete="off"
                          style="width: 100%;"></el-input>
            </el-form-item>
            <el-form-item label="健康管理助理职称" prop="manager_title_id">
                <el-select :disabled="managerTitleDisabled" v-model="ruleForm.manager_title_id" placeholder="请选择健康管理助理职称"
                           style="width:100%;">
                    <el-option
                        v-for="item in allManagerTitle "
                        :key="item.id"
                        :label="item.title_name"
                        :value="item.id"
                    ></el-option>
                </el-select>
<!--                <el-button type="danger" plain style="margin-left: 0.5em;width: 7em" @click="addManagerTitle">新增职称</el-button>-->
            </el-form-item>
            <el-form-item label="运营负责公司" prop="company_id" v-if="ruleForm.doctor_id">
                <el-select disabled @change="changeCompany" v-model="ruleForm.company_id" placeholder="运营负责公司"
                           style="width: 100%;">
                    <el-option
                        v-for="item in allCompany"
                        :key="item.id"
                        :label="item.company_name"
                        :value="item.id"
                    ></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="运营负责部门" v-if="ruleForm.doctor_id">
                <el-select disabled @change="changeDeparment" v-model="ruleForm.company_department_id"
                           placeholder="运营负责部门"
                           style="width: 100%;">
                    <el-option
                        v-for="item in allCompanyDeparment"
                        :key="item.id"
                        :label="item.department_name"
                        :value="item.id"
                    ></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="运营负责组" v-if="ruleForm.doctor_id">
                <el-select disabled v-model="ruleForm.company_group_id" placeholder="运营负责组"
                           style="width: 100%;">
                    <el-option
                        v-for="item in allCompanyGroup"
                        :key="item.id"
                        :label="item.group_name"
                        :value="item.id"
                    ></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="运营负责人" v-if="ruleForm.doctor_id">
                <el-input disabled type="text" v-model="ruleForm.operate_user_name" autocomplete="off" placeholder="运营负责人"
                          style="width: 100%;"></el-input>
            </el-form-item>
            <el-form-item label="状态" prop="status">
                <el-radio-group v-model="ruleForm.status">
                    <el-radio :label="1">启用</el-radio>
                    <el-radio :label="2">停用</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item label="专长">
                <el-input type="textarea" v-model="ruleForm.introduction" maxlength="80"
                          show-word-limit
                          autosize placeholder="请输入专长" autocomplete="off"
                          style="width: 100%;"></el-input>
            </el-form-item>
            <el-form-item label="头像">
                <div class="avatar-uploader">
                    <label class="avatar-btn avatar" for="uploads">
                        <img style=" width: 200px;height: 280px;" v-if="userAvaratImageUrl" :src="userAvaratImageUrl"
                             class="avatar">
                        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                    </label>
                </div>
                <input type="file" id="uploads" style="position:absolute; clip:rect(0 0 0 0);"
                       accept="image/png, image/jpeg, image/gif, image/jpg" @change="selectImg($event)">
            </el-form-item>
            <el-form-item label="协议编号">
                <el-input type="text" v-model="ruleForm.contract_title" placeholder="请输入协议编号" autocomplete="off"
                          style="width: 100%;"></el-input>
            </el-form-item>
            <el-form-item label="签约日期" prop="start_date">
                <el-date-picker v-model="ruleForm.start_date" type="date" placeholder="选择日期" format="yyyy-MM-dd"
                                value-format="yyyy-MM-dd"  @change="getExpiredDate(ruleForm.is_expired)">
                </el-date-picker>
            </el-form-item>
            <el-form-item label="签约协议文件" :label-width="formLabelWidth" style="transform: translateX(2em)">
                <el-upload ref="upload" class="upload-demo" accept=".jpg,.png,.jpeg,.JPEG,.JPG,.PNG,.pdf,.PDF"
                           :action="upload_agreement_path" :file-list="fileList"
                           :on-success="handleSuccess" :before-upload="beforeAvatarUpload" list-type="picture"
                           :multiple="true" :limit="9">
                    <div slot="file" slot-scope="{file}">
                        <pdf class="el-upload-list__item-thumbnail"  v-if="file.name.endsWith('.pdf')" :src="file.url"></pdf>
                        <img v-else class="el-upload-list__item-thumbnail" :src="file.url" alt=""/>
                        <a class="el-upload-list__item-name"><i class="el-icon-document"></i>{{ file.name }}</a>
                        <label class="el-upload-list__item-status-label">
                            <i class="el-icon-upload-success el-icon-check"></i>
                        </label>
                        <i class="el-icon-close" @click="handleRemoveFile(file)"></i>
                        <i class="el-icon-close-tip">按 delete 键可删除</i>
                    </div>

                    <el-button class="upload_btn" size="small" type="primary" v-if="addFileList.length < 9">点击上传
                    </el-button>
                    <div slot="tip" class="el-upload__tip" v-if="addFileList.length < 9">注：格式支持PNG,JPG,PDF
                    </div>
                </el-upload>

                <div class="upload-demo">
                    <el-button class="file_view" size="small" type="primary"
                               @click="oneReservationDetail({contract_file: JSON.stringify(addFileList)})">预览协议
                    </el-button>
                </div>

            </el-form-item>
            <el-form-item label="身份证照片">
                <div>
                    <div style="float: left;margin-left: 2px">
                        <el-input type="hidden" v-model="ruleForm.idcard_img_up" placeholder="身份证正面照片"
                                  style="width: 100%;"></el-input>
                        <el-upload
                            class="avatar-uploader"
                            :action="upload_path"
                            :show-file-list="false"
                            :on-success="handleIdCartUpImgSuccess"
                            :before-upload="beforeAvatarUpload">
                            <img style=" width: 316px;height: 200px;" v-if="idcartUpImageUrl" :src="idcartUpImageUrl"
                                 class="avatar">
                            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                        </el-upload>
                        <div>请上传jpg/png格式的身份证正面照片</div>
                    </div>
                    <div style="float: left;margin-left: 20px;">
                        <el-input type="hidden" v-model="ruleForm.idcard_img_down" placeholder="身份证反面照片"
                                  style="width: 100%;"></el-input>
                        <el-upload
                            class="avatar-uploader"
                            :action="upload_path"
                            accept=".jpg,.png,.jpeg,.JPEG,.JPG,.PNG"
                            :show-file-list="false"
                            :on-success="handleIdCartDownImgSuccess"
                            :before-upload="beforeAvatarUpload">
                            <img style=" width: 316px;height: 200px;" v-if="idcartDownImageUrl" :src="idcartDownImageUrl"
                                 class="avatar">
                            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                        </el-upload>
                        <div>请上传jpg/png格式的身份证反面照片</div>
                    </div>
                </div>
            </el-form-item>
            <el-form-item label="银行卡照片">
                <el-input type="hidden" v-model="ruleForm.bankcard_img" placeholder="银行卡照片"
                          style="width: 100%;"></el-input>
                <el-upload
                    class="avatar-uploader"
                    :action="upload_path"
                    accept=".jpg,.png,.jpeg,.JPEG,.JPG,.PNG"
                    :show-file-list="false"
                    :on-success="handleBankCartImgSuccess"
                    :before-upload="beforeAvatarUpload">
                    <img style=" width: 316px;height: 200px;" v-if="bankcartImageUrl" :src="bankcartImageUrl"
                         class="avatar">
                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                </el-upload>
                <div>请上传jpg/png格式的银行卡照片</div>
            </el-form-item>
            <el-form-item>
                <el-button @click="goBack">取消</el-button>
                <el-button type="success" @click="submitForm('ruleForm')">保存</el-button>
            </el-form-item>
        </el-form>


        <el-dialog title="头像裁剪" :visible.sync="dialogVisible" append-to-body @close="closeDialog">
            <div class="cropper-content">
                <div class="cropper" style="text-align:center">
                    <vue-cropper
                        ref="cropper"
                        :img="option.img"
                        :autoCrop="true"
                        :fixed="true"
                        :fixedNumber="[5, 7]">
                    </vue-cropper>
                </div>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <label class="el-button el-button--primary" for="suploads" style="margin-right: 10px;"><span>重新选择</span></label>
                <input type="file" id="suploads" style="position:absolute; clip:rect(0 0 0 0);"
                       accept="image/png, image/jpeg, image/gif, image/jpg" @change="selectImg($event)">
                <el-button type="primary" @click="uploadImg('blob')" :loading="loading">确认</el-button>
            </div>
        </el-dialog>

        <el-dialog title="协议详情" :visible.sync="dialogContractFormVisible">
            <el-carousel indicator-position="outside" height="500px" :autoplay="false">
                <el-carousel-item v-for="(url, n) in allContractUrls" :key="n">
                    <div class="image_box" v-if="getFileType(url.src) == 'pdf'">
                        <pdf
                            v-for="i in url.pages"
                            :key="i"
                            :page="i"
                            :src="url.src" ></pdf>
                    </div>
                    <div class="image_box" v-if="getFileType(url.src) != 'pdf'">
                        <el-image :src="url.src"></el-image>
                    </div>
                </el-carousel-item>
            </el-carousel>
        </el-dialog>
    </div>
</template>
<script>
import env from "@/api/env";
import {getUserInfos} from '@/utils/userInfos';
import {check} from "@/utils/checkData";
import {VueCropper} from "vue-cropper";
import {authUrlCheck, fileType, userNameCheck} from "@/api/order";
import pdf from "vue-pdf";

export default {
    components: {
        VueCropper,
        pdf
    },
    created() {
        localStorage.setItem('prev_page', 'manager_edit')
        if (this.$route.query.user_id) {
            this.user_id = this.$route.query.user_id;

        } else {
            this.user_id = this.$route.params.user_id;

        }
        this.getDetail()
    },
    mounted() {
        this.createParams();
        this.getAllDeparment();
        this.getAllCompanyGroup();
    },
    data() {
        return {
            upload_path: env.IMG_COMMON_REQUEST_URL_PREFIX + '?type=1',
            upload_agreement_path: env.IMG_COMMON_REQUEST_URL_PREFIX + '?type=99',
            userAvaratImageUrl: '',
            idcartUpImageUrl: '',
            idcartDownImageUrl: '',
            bankcartImageUrl: '',
            imgUrl: env.IMG_COMMON_URL_PREFIX,
            formLabelWidth: '120px',
            fileList: [],
            addFileList: [],
            allContractUrls: [],
            user_id: '',
            allCompany: [],
            managerTitleDisabled: false,
            dialogContractFormVisible: false,
            allCompanyDeparment: [],
            allCompanyGroup: [],
            allManagerTitle: [],
            old_doctor_id: '',
            old_doctor_name:'',
            ruleForm: {
                user_name: "",
                mobile: "",
                idcard: "",
                idcard_img_up: "",
                idcard_img_down: "",
                bank_card: "",
                bankcard_img: "",
                doctor_id: "",
                doctor_name: "",
                hospital_id: "",
                hospital_name: "",
                manager_title_id: "",
                company_id: "",
                company_department_id: "",
                company_group_id: "",
                status: 1,
                user_avatar: '',
                operate_user_name: '',
                operate_user_id: '',
                introduction: '',
                start_date: "", // 签约日期
                old_expired_date: "", // 旧签约日期
                contract_title: "", // 协议编号
                posistion: "", // 职务
            },
            rules: {
                user_name: [
                    {required: true, message: "请输入健康管理助理姓名", trigger: "blur"},
                ],
                mobile: [
                    {required: true, message: "请输入手机号码", trigger: "blur"},
                ],
                idcard: [
                    {required: true, message: "请输入身份证号码", trigger: "blur"},
                ],
                doctor_id: [
                    {required: true, message: "请选择绑定健康管理专家", trigger: "blur"},
                ],
                hospital_id: [
                    {required: true, message: "请选择单位", trigger: "blur"},
                ],
                manager_title_id: [
                    {required: true, message: "请选择健康管理助理职称", trigger: "blur"},
                ],
                company_id: [
                    {required: true, message: "请输入所属公司", trigger: "blur"},
                ],
                company_department_id: [
                    {required: true, message: "请选择所属部门", trigger: "blur"},
                ],
                company_group_id: [
                    {required: true, message: "请选择所属组", trigger: "blur"},
                ],
                status: [
                    {required: true, message: "请选择状态", trigger: "blur"},
                ],
                user_avatar: [
                    {required: true, message: "请选择头像", trigger: "blur"},
                ],

            },
            dialogVisible: false,
            // 防止重复提交
            loading: false,
            option: {
                img: '',             //裁剪图片的地址
            },
            is_submit: false,
            is_user_name: true, // 用户名输入是否正确
        };
    },
    methods: {
        getFileType(url) {
            return fileType(url)
        },
        // 用户名中文验证
        userNameCheck(e) {
            if (e) {
                this.is_user_name = userNameCheck(e)
            } else {
                this.is_user_name = true
            }
        },
        // 获取详情
        async getDetail() {
            let params = {
                servername: 'Ruyi_AssistantAdminServices',
                method: 'assistantDetail',
                params: {
                    user_id: this.user_id,
                    status: 1
                }
            };
            await this.$api.service(params).then(res => {
                if (!check(res)) {
                    return;
                }
                let data = res.data.data.assistant_detail
                this.ruleForm.user_name = data.user_name;
                this.ruleForm.mobile = data.mobile;
                this.ruleForm.idcard = data.idcard;
                this.ruleForm.company_id = data.company_id;
                this.ruleForm.posistion = data.posistion;
                if (data.company_id) {
                    this.getAllDeparment()
                }
                this.ruleForm.company_department_id = data.company_department_id;
                if (data.company_department_id) {
                    this.getAllCompanyGroup()
                }
                this.ruleForm.company_group_id = data.company_group_id;
                this.ruleForm.status = parseInt(data.status);
                if (data.user_avatar) {
                    this.ruleForm.user_avatar = data.user_avatar;
                    this.userAvaratImageUrl = this.imgUrl + this.ruleForm.user_avatar;
                }

                this.ruleForm.doctor_id = data.doctor_id;
                this.old_doctor_id = data.doctor_id;
                this.old_doctor_name = this.ruleForm.doctor_name = data.doctor_name;
                this.ruleForm.hospital_id = data.hospital_id;
                this.ruleForm.hospital_name = data.hospital_name;
                this.ruleForm.manager_title_id = data.manager_title_id;
                this.ruleForm.introduction = data.introduction;
                this.ruleForm.bank_card = data.bank_card;
                if (data.bankcard_img) {
                    this.ruleForm.bankcard_img = data.bankcard_img;
                    this.bankcartImageUrl = this.imgUrl + data.bankcard_img;
                }
                if (data.idcard_img_up) {
                    this.ruleForm.idcard_img_up = data.idcard_img_up;
                    this.idcartUpImageUrl = this.imgUrl + data.idcard_img_up;
                }
                if (data.idcard_img_down) {
                    this.ruleForm.idcard_img_down = data.idcard_img_down;
                    this.idcartDownImageUrl = this.imgUrl + data.idcard_img_down;
                }

                if (data.operate_user_id) {
                    this.ruleForm.operate_user_name = data.operate_user_name
                    this.ruleForm.operate_user_id = data.operate_user_id
                }
                if (data.doctor_id) {
                    this.getContractInfo(data.doctor_id)
                }

            });
        },
        // 所有咨询者，健康管理专家
        createParams() {
            let params = {
                servername: 'Ruyi_AdminOperateServices',
                method: 'createCompanyDeparmentParams',
                params: {
                    company_id: this.ruleForm.company_id,
                    status: 1
                }
            };
            this.$api.service(params).then(res => {
                if (!check(res)) {
                    return;
                }
                this.allCompany = res.data.data.all_company;
                this.allManagerTitle = res.data.data.all_manager_title;
            });
        },

        getAllDeparment() {
            let params = {
                servername: 'Ruyi_AdminOperateServices',
                method: 'getAllCompanyDeparment',
                params: {
                    company_id: this.ruleForm.company_id,
                    deparment_id: this.ruleForm.company_department_id,
                    status: 1
                }
            };
            this.$api.service(params).then(res => {
                if (!check(res)) {
                    return;
                }
                this.allCompanyDeparment = res.data.data;
            });
        },

        getAllCompanyGroup() {
            let params = {
                servername: 'Ruyi_AdminOperateServices',
                method: 'getAllCompanyGroup',
                params: {
                    company_id: this.ruleForm.company_id,
                    department_id: this.ruleForm.company_department_id,
                    group_id: this.ruleForm.company_group_id,
                    status: 1
                }
            };
            this.$api.service(params).then(res => {
                if (!check(res)) {
                    return;
                }
                this.allCompanyGroup = res.data.data;
            });
        },

        // 返回上一页
        goBack() {

            localStorage.setItem('manager_detail_user_id', this.user_id)
            window.history.go(-1);
            return;
        },

        // 提交表单
        submitForm(formName) {
            if (this.is_submit) {
                // 重复提交提醒
                this.$message({
                    type: "warning",
                    message: '正在处理请求，请不要重复提交',
                    duration: 1500,
                });
                return;
            }
            this.is_submit = true;
            let _that = this
            this.$refs[formName].validate(valid => {
                if (valid) {
                    let params = {
                        'servername': 'Ruyi_AssistantAdminServices',
                        'method': 'assistantEdit',
                        'params': {
                            user_id: this.user_id,
                            user_name: this.ruleForm.user_name,
                            mobile: this.ruleForm.mobile,
                            idcard: this.ruleForm.idcard,
                            company_id: this.ruleForm.company_id,
                            company_department_id: this.ruleForm.company_department_id,
                            company_group_id: this.ruleForm.company_group_id,
                            user_avatar: this.ruleForm.user_avatar,
                            status: this.ruleForm.status,
                            doctor_id: this.ruleForm.doctor_id,
                            manager_title_id: this.ruleForm.manager_title_id,
                            hospital_id: this.ruleForm.hospital_id,
                            operate_user_id: this.ruleForm.operate_user_id,
                            introduction: this.ruleForm.introduction,
                            idcard_img_up: this.ruleForm.idcard_img_up,
                            idcard_img_down: this.ruleForm.idcard_img_down,
                            bankcard_img: this.ruleForm.bankcard_img,
                            bank_card: this.ruleForm.bank_card,
                            protocol_file: this.addFileList,
                            start_date: this.ruleForm.start_date,
                            contract_title: this.ruleForm.contract_title,
                            posistion: this.ruleForm.posistion,
                        }
                    };
                    this.$api.service(params).then(res => {
                        if (!check(res)) {
                            this.is_submit = false;
                            return;
                        }
                        this.$message({
                            type: "success",
                            message: '编辑成功',
                            duration: 1500,
                            onClose: function () {
                                _that.is_submit = false;
                                window.history.go(-1);
                                return;
                            }
                        });
                    }).catch(()=>{
                        this.is_submit = false;
                    }).finally(() => {
                        this.is_submit = false;
                    });
                } else {
                    this.$message({
                        type: "error",
                        message: '请输入必填项'
                    });
                    this.is_submit = false;
                    return false;
                }
            });
        },

        changeCompany() {
            this.ruleForm.company_department_id = '';
            this.ruleForm.company_group_id = '';
            this.getAllDeparment();
        },
        changeDeparment() {
            this.ruleForm.company_group_id = '';
            this.getAllCompanyGroup();
        },
        handleUserAvatarImgSuccess(res) {
            if (res.code == 0) {
                this.ruleForm.user_avatar = res.data;
                this.userAvaratImageUrl = this.imgUrl + res.data;
            } else {
                this.$message({
                    type: "error",
                    message: res.msg,
                });
            }
        },
        // 上传身份证图片
        handleIdCartUpImgSuccess(res) {
            if (res.code == 0) {
                this.ruleForm.idcard_img_up = res.data;
                this.idcartUpImageUrl = this.imgUrl + res.data;
            } else {
                this.$message({
                    type: "error",
                    message: res.msg,
                });
            }
        },
        // 上传身份证图片
        handleIdCartDownImgSuccess(res) {
            if (res.code == 0) {
                this.ruleForm.idcard_img_down = res.data;
                this.idcartDownImageUrl = this.imgUrl + res.data;
            } else {
                this.$message({
                    type: "error",
                    message: res.msg,
                });
            }
        },
        // 上传银行卡图片
        handleBankCartImgSuccess(res) {
            if (res.code == 0) {
                this.ruleForm.bankcard_img = res.data;
                this.bankcartImageUrl = this.imgUrl + res.data;
            } else {
                this.$message({
                    type: "error",
                    message: res.msg,
                });
            }
        },
        //上传图片之前，检测文件格式
        beforeAvatarUpload(file) {
            if (file.type === 'image/jpeg' || file.type === 'image/png' || file.type === 'application/pdf') {
                var isJPG = true;
            } else {
                var isJPG = false;
            }
            const isLt5M = file.size / 1024 / 1024 < 5;
            if (!isJPG) {
                this.$message.error('图片只能是jpg/png/pdf格式!');
            }
            // if (!isLt5M) {
            //     isJPG = false;
            //     this.$message.error('图片大小不能超过5MB!');
            //
            // }
            return isJPG;
        },
        //选择图片
        selectImg(e) {
            let file = e.target.files[0]
            if (!/\.(jpg|jpeg|png|JPG|PNG)$/.test(e.target.value)) {
                this.$message({
                    message: '图片类型要求：jpeg、jpg、png',
                    type: "error"
                });
                return false
            }
            //转化为blob
            let reader = new FileReader()
            reader.onload = (e) => {
                let data
                if (typeof e.target.result === 'object') {
                    data = window.URL.createObjectURL(new Blob([e.target.result]))
                } else {
                    data = e.target.result
                }
                this.option.img = data
                this.dialogVisible = true;
            }
            //转化为base64
            reader.readAsDataURL(file)
        },
        //上传图片
        uploadImg(type) {
            let _this = this;
            if (type === 'blob') {
                //获取截图的blob数据
                this.$refs.cropper.getCropBlob(async (data) => {

                    let formData = new FormData();
                    formData.append('file', data, ".jpg")

                    await _this.$api.avatar_upload_file(formData).then(res => {
                        if (!check(res)) {
                            return;
                        }
                        if (res.data.code == 0) {
                            _this.ruleForm.user_avatar = res.data.data;
                            _this.userAvaratImageUrl = this.imgUrl + res.data.data;
                            _this.dialogVisible = false;
                        } else {
                            _this.$message({
                                type: "error",
                                message: res.data.msg,
                            });
                        }
                    })

                })
            }
        },
        // 关闭对话框清除之前选择的文件
        closeDialog() {
            document.getElementById('uploads').value = ''
            document.getElementById('suploads').value = ''
        },
        getDoctor(key, cb) {
            if (!key || this.search_key == key) {
                cb([{"value": "请输入健康管理专家姓名关键词"}]);
                return;
            }
            this.search_key = key
            let params = {
                servername: 'Ruyi_AssistantAdminServices',
                method: 'searchDoctor',
                params: {
                    doctor_name: key,
                    doctor_id: this.old_doctor_id,
                }
            };
            this.$api.service(params).then(res => {
                if (!check(res)) {
                    return;
                }
                if (res.data.code != '0') {
                    this.$message({
                        type: "error",
                        message: res.data.msg,
                        duration: 1500,
                    });
                    return;
                }
                // this.use_doctors = res.data.data
                var doctors = res.data.data
                if (!doctors) {
                    return  cb([{"value": "没有找到健康管理专家"}]);
                }
                if (doctors) {
                    let res = Object.values(doctors)
                    for (var i = 0; i < res.length; i++) {
                        res[i].value = `${res[i].user_name}`
                    }
                    cb(res);
                }

            });
        },
        async doctorSelect(item) {
            this.rules.company_id = item.company_id
            this.ruleForm.doctor_id = item.user_id;
            this.ruleForm.doctor_name = item.user_name;
            this.ruleForm.hospital_id = item.hospital_id;
            this.ruleForm.hospital_name = item.hospital_name;
            if (item.company_id) {
                await this.getAllDeparment()
                this.ruleForm.company_department_id = item.department_id
            }
            if (item.department_id) {
                await this.getAllCompanyGroup()
                this.ruleForm.company_group_id = item.group_id
            }
            this.ruleForm.operate_user_id = item.operate_user_id
            this.ruleForm.operate_user_name = item.operate_user_name
            this.old_doctor_name = this.ruleForm.doctor_name
            // 选择专家后获取签约情况
            this.getContractInfo(item.user_id)
        },
        resetDoctorInfo() {
            if (this.ruleForm.doctor_id) {
                this.ruleForm.doctor_name = this.old_doctor_name
            }

        },
        getExpiredDate(type) {
            let baseDate = ''

            if(type == 2) {
                baseDate = this.ruleForm.old_expired_date
            } else {
                if (!this.ruleForm.start_date) return
                baseDate = this.ruleForm.start_date
            }

            let date = new Date(baseDate)
            let y = date.getFullYear() + this.ruleForm.year;
            let m = date.getMonth() + 1;
            let d = date.getDate()
            this.ruleForm.expired_date = `${y}-${m}-${d}`
        },
        // 除去图片
        handleRemove(file, fileList) {
            var addFileList = [];
            var imageUrl = this.imgUrl;
            for (var i = 0; i < fileList.length; i++) {
                if (fileList[i].status == 'success') {
                    if (fileList[i].response && fileList[i].response.data) {
                        addFileList.push(fileList[i].response.data);
                    } else {
                        let name = fileList[i].url.substring(imageUrl.length, fileList[i].url.length);
                        addFileList.push(name);
                    }
                }
            }
            this.addFileList = addFileList;
        },
        // 上传图片成功
        handleSuccess(response, file, fileList) {
            var addFileList = [];
            var imageUrl = this.imgUrl;
            for (var i = 0; i < fileList.length; i++) {
                if (fileList[i].status == 'success') {
                    if (fileList[i].response && fileList[i].response.data) {
                        if (fileList[i].response.data.file) {
                            addFileList.push(fileList[i].response.data);
                        } else {
                            addFileList.push({
                                file:fileList[i].response.data
                            });
                        }
                    }
                }
            }

            this.addFileList = addFileList;
            this.ruleForm.file = "file";
        },
        // 协议详情-预览
        async oneReservationDetail(data) {
            this.allContractUrls = [];
            let allContractUrls = [];
            if (data.contract_file) {
                let contract_file = JSON.parse(data.contract_file);
                let url = '';
                let local_url = '';
                let num_pages = 0;
                if (contract_file.length > 0) {
                    for (let i = 0; i < contract_file.length; i++) {
                        local_url = url = this.imgUrl + contract_file[i].file;
                        num_pages = 0;
                        // allContractUrls.push(url);
                        if (this.getFileType(url) == 'pdf') {
                            url = pdf.createLoadingTask(url)
                            await url.promise.then(pdf => {
                                num_pages = pdf.numPages
                                allContractUrls.push({
                                    src: local_url,
                                    pages: num_pages
                                });
                            });

                        } else {
                            allContractUrls.push({
                                src: local_url,
                                pages: num_pages
                            });
                        }
                    }
                }
            }
            this.allContractUrls = allContractUrls;
            this.dialogContractFormVisible = true;
        },
        handleRemoveFile(file) {

            this.$refs.upload.handleRemove(file)
            for (let i=0;i<this.addFileList.length; i++) {
                if (file.response.data.file == this.addFileList[i].file) {
                    this.addFileList.splice(i, 1);
                }
            }
        },
        // 获取详情
        async getContractInfo(doctor_id) {
            let params = {
                servername: 'Ruyi_AssistantAdminServices',
                method: 'assistantContract',
                params: {
                    user_id: this.user_id,
                    doctor_id: doctor_id,
                }
            };
            await this.$api.service(params).then(res => {
                if (!check(res)) {
                    return;
                }
                let data = res.data.data
                if (data) {
                    // 协议部分
                    this.ruleForm.start_date = data.start_date;
                    this.ruleForm.contract_title = data.contract_title;

                    // 协议文件
                    if (data.contract_file != null) {
                        let file_arr = JSON.parse(data.contract_file)

                        let index = null;
                        let name = null;
                        for (let i=0; i< file_arr.length;i++) {
                            index = file_arr[i].file.lastIndexOf("/");
                            name  = file_arr[i].file.substring(index + 1, file_arr[i].file.length);
                            this.fileList.push({
                                response: {
                                    data: {
                                        file: file_arr[i].file
                                    }
                                },
                                name: name,
                                url: this.imgUrl + file_arr[i].file,
                            });
                            this.addFileList.push({
                                name: name,
                                file: file_arr[i].file,
                            });
                        }
                        this.ruleForm.file = "file";
                    }
                }
            });
        },
    }

};
</script>
<style lang="scss">
@import "@/styles/common.scss";

.doctor_search {
    text-align: left;
    width: 100%;
}

.cropper-content {
    .cropper {
        width: auto;
        height: 280px;
    }
}

.avatar-btn, .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
}

.avatar-btn {
    display: inline-block;
    text-align: center;
}

.avatar-btn, .avatar-uploader .el-upload:hover {
    border-color: #d9d9d9;
}

.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 200px;
    height: 200px;
    line-height: 200px;
    text-align: center;
}

.avatar-btn {
    width: 200px;
    height: 200px;
}

.avatar{
    .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 200px;
        height: 280px;
        line-height: 280px;
        text-align: center;
    }
}

.avatar-btn.avatar{
    width: 200px;
    height: 280px;
}

.editor {
    line-height: normal !important;
    height: 800px;
}

.upload_btn {
    position: absolute;
    top: 0;
    left: 30px;
}

.file_view {
    position: absolute;
    top: 0;
    left: 130px;
}

.ql-snow .ql-tooltip[data-mode=link]::before {
    content: "请输入链接地址:";
}

.ql-snow .ql-tooltip.ql-editing a.ql-action::after {
    border-right: 0px;
    content: '保存';
    padding-right: 0px;
}

.ql-snow .ql-tooltip[data-mode=video]::before {
    content: "请输入视频地址:";
}

.ql-snow .ql-picker.ql-size .ql-picker-label::before,
.ql-snow .ql-picker.ql-size .ql-picker-item::before {
    content: '14px';
}

.ql-snow .ql-picker.ql-size .ql-picker-label[data-value=small]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value=small]::before {
    content: '10px';
}

.ql-snow .ql-picker.ql-size .ql-picker-label[data-value=large]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value=large]::before {
    content: '18px';
}

.ql-snow .ql-picker.ql-size .ql-picker-label[data-value=huge]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value=huge]::before {
    content: '32px';
}

.ql-snow .ql-picker.ql-header .ql-picker-label::before,
.ql-snow .ql-picker.ql-header .ql-picker-item::before {
    content: '文本';
}

.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="1"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="1"]::before {
    content: '标题1';
}

.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="2"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="2"]::before {
    content: '标题2';
}

.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="3"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="3"]::before {
    content: '标题3';
}

.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="4"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="4"]::before {
    content: '标题4';
}

.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="5"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="5"]::before {
    content: '标题5';
}

.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="6"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="6"]::before {
    content: '标题6';
}

.ql-snow .ql-picker.ql-font .ql-picker-label::before,
.ql-snow .ql-picker.ql-font .ql-picker-item::before {
    content: '标准字体';
}

.ql-snow .ql-picker.ql-font .ql-picker-label[data-value=serif]::before,
.ql-snow .ql-picker.ql-font .ql-picker-item[data-value=serif]::before {
    content: '衬线字体';
}

.ql-snow .ql-picker.ql-font .ql-picker-label[data-value=monospace]::before,
.ql-snow .ql-picker.ql-font .ql-picker-item[data-value=monospace]::before {
    content: '等宽字体';
}
</style>
